import { Routes } from '@angular/router';
import { ownerGuard } from '../../auth/guards/owner.guard';
import { ClientsPageComponent } from './pages/clients-page/clients-page.component';

export const clientsRoutes: Routes = [
  {
    path: 'clients',
    canActivate: [ownerGuard],
    component: ClientsPageComponent,
  },
];
